<template>
  <v-data-table
    :items="allInvoices"
    :headers="headers"
    mobile-breakpoint="0"
    hide-default-footer
    class="rounded-lg mt-2"
    style="overflow-y: auto;"
  >
    <template #item.invoice_id="{ item }">
      <router-link :to="{ name: 'billing/statements/show', params: { invoice_id: item.invoice_id } }">
        {{ item.invoice_id }}
      </router-link>
    </template>

    <template #item.invoice_date="{ item }">
      {{ formatDateMY(item.invoice_date) }}
    </template>

    <template #item.total_cents="{ item }">
      {{ formatCurrency(item.total_cents) }}
    </template>
  </v-data-table>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'BillingInvoicesTab',

  data() {
    return {
      headers: [
        { text: 'Statement #', value: 'invoice_id', class: 'fitwidth pr-2', cellClass: 'fitwidth pr-2' },
        { text: 'Date', value: 'invoice_date', class: 'fitwidth px-2', cellClass: 'fitwidth px-2' },
        { text: 'Amount', value: 'total_cents', align: 'end', class: 'fitwidth pl-2', cellClass: 'fitwidth pl-2' },
      ],
    }
  },

  computed: {
    ...mapGetters('billing', ['allInvoices'])
  },

  methods: {
    ...mapActions('billing', ['loadAllInvoices']),

    ...formatters,

    invoiceClick(invoice) {
      this.$router.push({ name: 'billing/statements/show', params: { invoice_id: invoice.invoice_id } })
    }
  },

  created() {
    this.loadAllInvoices()
  }
}
</script>

<style>
  .fitwidth {
    width: 1px;
    white-space: nowrap;
  }
</style>
